import configurationList from "./company-configurations";
import integrationList from "./integration-list";

import { combineReducers } from "redux";

export default combineReducers({
  configurationList,
  integrationList,
});
